(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["29-journey-bridge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('journey-anchor-navigation')) {
  class JourneyAnchorNavigation extends HTMLElement {
    connectedCallback() {
      this.onClick = event => {
        const link = event.target.closest('header-drawer a[href]');
        if (!link) return;
        const url = new URL(link.href, window.location.href);
        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || !['#flavour-worlds', '#home-brewing', '#art-and-coffee'].includes(url.hash)) return;
        const drawer = link.closest('header-drawer');
        const target = document.getElementById(url.hash.slice(1));
        if (!target || typeof drawer?.closeMenuDrawer !== 'function') return;
        drawer.closeMenuDrawer(event, false);
        drawer.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        target.setAttribute('tabindex', '-1');
        target.focus({preventScroll: true});
      };
      document.addEventListener('click', this.onClick);
    }
    disconnectedCallback() { document.removeEventListener('click', this.onClick); }
  }
  customElements.define('journey-anchor-navigation', JourneyAnchorNavigation);
  document.body.append(document.createElement('journey-anchor-navigation'));
}
  } catch(e) { console.error(e); }
})();

})();
